import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

import { FormSubmittedActionItem } from '../types'
import FormDownloadPDFAction from './download-pdf-action'
import FormMarkCompleteAction from './mark-complete-action'
import FormViewSubmissionAction from './view-submission-action'
import { FormType } from '~graphql/generated/graphql'
import FormSubmittedAssignClientAction from './assign-client-action'
import FormSubmittedAssignPatientAction from './assign-patient-action'

interface Props {
    actionItem: FormSubmittedActionItem
    isHistorical?: boolean
    isSmall?: boolean
}

export default function FormSubmittedActions({
    actionItem,
    isHistorical,
    isSmall = false,
}: Props) {
    if (!actionItem.client_form) {
        return <Box display="none" />
    }

    if (isHistorical) {
        return (
            <FormDownloadPDFAction actionItem={actionItem} isSmall={isSmall} />
        )
    }

    const { client, patient, form } = actionItem.client_form
    const needsClient = form.form_type === FormType.Client && !client
    const needsPatient = form.form_type === FormType.Patient && !patient

    return (
        <Flex
            gap={2}
            flexDirection={{ base: 'row-reverse', md: 'column' }}
            w={{ base: 'full', md: 'max-content' }}
        >
            {needsClient && (
                <FormSubmittedAssignClientAction
                    clientForm={actionItem.client_form}
                    isSmall={isSmall}
                />
            )}
            {needsPatient && (
                <FormSubmittedAssignPatientAction
                    clientForm={actionItem.client_form}
                    isSmall={isSmall}
                />
            )}
            <FormViewSubmissionAction
                actionItem={actionItem}
                isSmall={isSmall}
            />
            <FormMarkCompleteAction
                actionItemId={actionItem.id}
                isSmall={isSmall}
            />
        </Flex>
    )
}
